import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import PropTypes from 'prop-types'
import ParallaxImage from './parallaxImage'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { ContentTypeSlugMap } from '../../lib/constants'
import { localisedLink } from '../../utils/utils'

const ParallaxWrapper = styled.div`
    position: relative;
    min-height: 100vh;
    width: 100vw;
`

const MainAssets = () => {
    const { i18n } = useTranslation()

    const ourValues = useStaticQuery(
        graphql`
            query FetchAllMainAssets {
                allContentfulMainAssets(sort: {order: ASC}) {
                    nodes {
                        id
                        excerpt {
                            raw
                        }
                        slug
                        title
                        order
                        node_locale
                        featuredImage {
                            title
                            description
                            url
                            gatsbyImageData(
                                placeholder: BLURRED
                                height: 1920
                                width: 1920
                                quality: 75
                                sizes: "(max-width: 576px) 768px, (max-width: 768px) 960px, (max-width: 960px) 1200px"
                                layout: FULL_WIDTH
                                breakpoints: [576, 768, 960, 1200, 1920]
                            )
                        }
                          linkTo {
                            ... on ContentfulPage {
                              id
                              slug
                              internal {
                                type
                              }
                            }
                            ... on ContentfulLayoutPage {
                              id
                              slug
                              internal {
                                type
                              }
                            }
                          }
                    }
                }
            }
        `
    )

    const items = ourValues.allContentfulMainAssets.nodes

    return (
        <div>
            <ParallaxWrapper>
                {items.map(
                    (item) =>
                        i18n.language === item.node_locale && (
                            <div key={item.id}>
                                <ParallaxImage
                                    bgImage={item?.featuredImage?.url}
                                    slug={calculateUrl(item)}
                                    title={item.title}
                                    excerpt={item.excerpt}
                                />
                            </div>
                        )
                )}
            </ParallaxWrapper>
        </div>
    )
}

const calculateUrl = (item) => {
    return localisedLink(item.node_locale, ContentTypeSlugMap[item?.linkTo?.internal.type], item?.linkTo?.slug) || '/404'
}


MainAssets.defaultProps = {
    displayInHome: false,
}

MainAssets.propTypes = {
    displayInHome: PropTypes.bool,
}

export default MainAssets
